<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import FocusedMessage from "@/components/FocusedMessage.vue";

const { t } = useI18n();

const downloadLink = ref<HTMLAnchorElement | null>(null);

onMounted(() => {
  // Ensure the page is tracked before trigger download
  setTimeout(() => {
    downloadLink.value?.click();
  }, 500);
});
</script>

<template>
  <FocusedMessage>
    <template #message>
      <i18n-t keypath="downloadExamInformation.text">
        <template #link>
          <a
            ref="downloadLink"
            href="/assets/exam/abc-proeveinformation-2025-opdateret.pdf"
            class="download-exam-information__link"
            >{{ t("downloadExamInformation.link") }}</a
          >
        </template>
      </i18n-t>
    </template>
  </FocusedMessage>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.download-exam-information {
  &__link {
    color: rgb(@theme-colors[@primary][base]);
    text-decoration: underline;
  }
}
</style>
